// extracted by mini-css-extract-plugin
export default {"splitter":"contentSplitter_splitter__gBpFn","icon":"contentSplitter_icon__IuFIA"};